import { Lock, RotateCcw, Save } from "lucide-react";
import { Button, Card, CardHeader, Pill } from "../../../components/ui";

/**
 * Card wrapper for one settings section: title, unsaved indicator, Save / Reset.
 * `draft` is the object returned by useSectionDraft (omit for read-only sections).
 */
export default function SectionShell({ title, subtitle, icon, draft, readOnly, actions, children }) {
  const showControls = draft && !readOnly;
  return (
    <Card>
      <CardHeader
        title={title}
        subtitle={subtitle}
        icon={icon}
        actions={
          <>
            {actions}
            {readOnly && (
              <Pill tone="neutral">
                <Lock size={10} aria-hidden="true" /> Read-only
              </Pill>
            )}
            {showControls && draft.dirty && (
              <Pill tone="warning" dot>
                Unsaved changes
              </Pill>
            )}
            {showControls && (
              <>
                <Button size="sm" icon={RotateCcw} onClick={draft.reset} disabled={!draft.dirty || draft.saving}>
                  Reset
                </Button>
                <Button size="sm" variant="primary" icon={Save} onClick={draft.save} disabled={!draft.dirty || draft.saving}>
                  {draft.saving ? "Saving…" : "Save"}
                </Button>
              </>
            )}
          </>
        }
      />
      <div className="p-4">{children}</div>
    </Card>
  );
}

/** Small titled block inside a section. */
export function SubSection({ title, hint, children, className = "" }) {
  return (
    <div className={`flex flex-col gap-2.5 ${className}`}>
      <div>
        <h4 className="text-[12.5px] font-semibold text-text_primary">{title}</h4>
        {hint && <p className="text-[11.5px] text-text_muted">{hint}</p>}
      </div>
      {children}
    </div>
  );
}
